/**
 * <map-embed data-src="https://www.google.com/maps/embed?..." data-title="Map of …">
 * Adds the Google Maps iframe only once the element is on screen, so a page with maps
 * below the fold loads no Maps code for visitors who never scroll to them.
 * Without JavaScript the element stays an empty panel; the section's directions link
 * still works.
 */
class MapEmbed extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.src) return;

    if (!('IntersectionObserver' in window)) {
      this.load();
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.observer.disconnect();
        this.load();
      }
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  load() {
    if (this.querySelector('iframe')) return;

    const iframe = document.createElement('iframe');
    iframe.className = 'map-embed__frame';
    iframe.src = this.dataset.src;
    iframe.title = this.dataset.title || '';
    iframe.referrerPolicy = 'no-referrer-when-downgrade';
    iframe.allowFullscreen = true;
    iframe.addEventListener('load', () => this.classList.add('is-loaded'), { once: true });
    this.append(iframe);
  }
}

if (!customElements.get('map-embed')) {
  customElements.define('map-embed', MapEmbed);
}
